
import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {HarlequinReelView} from "./HarlequinReelView";
import {ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {HarlequinGameConfig} from "../HarlequinGameConfig";
import {TimelineLite} from "gsap";

export class HarlequinReelAreaView extends ReelAreaView {

    private _baseContainer:PIXI.Container;
    private _highContainer:PIXI.Container;

    private _baseMask:PIXI.Graphics;
    private _highMask:PIXI.Graphics;

    constructor(resourcesGroup?:ResourcesGroupName) {
        super(resourcesGroup);

        this._baseContainer = new PIXI.Container();
        this._highContainer = new PIXI.Container();

        this._layer.addChild(this._baseContainer);
        StageManager.getLayer(HarlequinGameConfig.instance.LAYERS.HIGH_SYMBOLS.name).addChild(this._highContainer);
    }

    protected initAnimations(): void {
        new TimelineLite().add(() => {
            this.onResize(this._resizeData);
        }, 5);
    }


    protected onResize(resizeData:IResizeData):void {

       //debugger;
        if(resizeData.orientation === Orientation.LANDSCAPE) {
            //this.scale.set(0.9, 0.9);
            this.x = 50; //GameConfig.instance.REEL_AREA_POS_X * 1.15;
            this.y = 193; //GameConfig.instance.REEL_AREA_POS_Y * 1.15 + 120;

            this._baseContainer.x = 35; //GameConfig.instance.REEL_AREA_POS_X * 1.15;
            this._baseContainer.y = 170; //GameConfig.instance.REEL_AREA_POS_Y * 1.15 + 120;
            this._baseContainer.scale.set(0.87, 0.87);

            this._highContainer.x = 35; //GameConfig.instance.REEL_AREA_POS_X * 1.15;
            this._highContainer.y = 170; //GameConfig.instance.REEL_AREA_POS_Y * 1.15 + 120;
            this._highContainer.scale.set(0.87, 0.87);
        }
        else {
            this.scale.set(1, 1);
            this.x = 0; //GameConfig.instance.REEL_AREA_POS_X;
            this.y = 50; //GameConfig.instance.REEL_AREA_POS_Y;

            this._baseContainer.scale.set(1, 1);
            this._baseContainer.x = 0; //GameConfig.instance.REEL_AREA_POS_X;
            this._baseContainer.y = 50; //GameConfig.instance.REEL_AREA_POS_Y;

            this._highContainer.scale.set(1, 1);
            this._highContainer.x = 0; //GameConfig.instance.REEL_AREA_POS_X;
            this._highContainer.y = 50; //GameConfig.instance.REEL_AREA_POS_Y;
        }

        this._reelViews.forEach((reelView:PIXI.Container, reelId:number) => {
            const position = GameConfig.instance.REEL_DISPLAY_POSITIONS[reelId];
            (<HarlequinReelView>reelView).updatePositions(position[0], position[1]);
        });

        //this._reelViews.forEach((reelView:Container, reelId:number) => {
            //this.updateReelViewPosition(reelView, reelId);
        //});

        this.UpdateReelAreaMask();
    }

    protected UpdateReelAreaMask():void {
        if(GameConfig.instance.REEL_AREA_MASK === false) {
            return;
        }

        if(this._baseMask) {
            this._baseMask.parent.removeChild(this._baseMask);
        }
        this._baseMask = this.getMaskShape();
        this._baseContainer.addChild(this._baseMask);
        this._baseContainer.mask = this._baseMask;

        if(this._highMask) {
            this._highMask.parent.removeChild(this._highMask);
        }
        this._highMask = this.getMaskShape();
        this._highContainer.addChild(this._highMask);
        this._highContainer.mask = this._highMask;
    }

    private getMaskShape():PIXI.Graphics {
        const rect:PIXI.Rectangle = GameConfig.instance.REEL_AREA_MASK_RECT != undefined ? GameConfig.instance.REEL_AREA_MASK_RECT :
            new PIXI.Rectangle(GameConfig.instance.REEL_AREA_POS_X, GameConfig.instance.REEL_AREA_POS_Y,
                GameConfig.instance.REEL_AREA_WIDTH, GameConfig.instance.REEL_AREA_HEIGHT);
        const maskShape = new PIXI.Graphics();
        maskShape.beginFill(0xFFFFFF, 1);
        maskShape.drawRect(rect.x - GameConfig.instance.REEL_AREA_POS_X, rect.y - GameConfig.instance.REEL_AREA_POS_Y, rect.width, rect.height);
        maskShape.endFill();
        return maskShape;
    }

    public addReelView(reel:ReelController):void {
        super.addReelView(reel);

        const view:HarlequinReelView = <HarlequinReelView> reel.view;
        this._baseContainer.addChild(view.baseContainter);
        this._highContainer.addChild(view.highContainer);
    }

}